import { render, staticRenderFns } from "./CreateReferralForm.vue?vue&type=template&id=0d3eb20c&scoped=true"
import script from "./CreateReferralForm.vue?vue&type=script&lang=js"
export * from "./CreateReferralForm.vue?vue&type=script&lang=js"
import style0 from "./CreateReferralForm.vue?vue&type=style&index=0&id=0d3eb20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3eb20c",
  null
  
)

export default component.exports